import { Table } from 'antd'
import { isArray } from 'lodash-es'
import { useEffect, useState } from 'react'

export default function PoolingTable(props: any) {
  const { data } = props
  const [column, setColumn] = useState<any>([])
  const [dataSource, setDataSource] = useState<any>([])
  useEffect(() => {
    dataHandle(data.capitalCateAmountList)
  }, [data])
  // 费用项映射表
  const feeItemMap = {
    addAmount: '增项金额(元)',
    replaceTotalAmount: '可替换总额(元)',
    addTotalAmount: '增项合计(元)',
    replaceBalanceAmount: '可替换余额(元)',
  }
  const dataHandle = (data: Array<any>) => {
    // 1.处理表头数据
    if (data && isArray(data)) {
      let column = [
        { title: '费用类型 | 品类', dataIndex: 'feeItem', key: 'feeItem' },
        ...data.map(item => ({
          title: item.cateName,
          dataIndex: item.cateName,
          key: item.cateName,
        })),
      ]
      let dataSource = Object.keys(feeItemMap).map((key, index) => {
        const row = { key: index.toString(), feeItem: feeItemMap[key] }
        data.forEach(item => {
          row[item.cateName] = item[key]
        })
        return row
      })
      setColumn(column)
      setDataSource(dataSource)
    }
  }
  return (
    <div>
      <Table dataSource={dataSource} columns={column} pagination={false} />
      <p dangerouslySetInnerHTML={{ __html: data?.capitalDesc || '' }}></p>
    </div>
  )
}
